export default () => ({
  lastFetched: "never",
  document_listener: null
});